import Header from "@/components/Header";
import Hero from "@/components/Hero";
import ResultsTicker from "@/components/ResultsTicker";
import EditorialMarquee from "@/components/Marquee";
import DailyQuote from "@/components/DailyQuote";
import TodayStrip from "@/components/TodayStrip";
import Manifesto from "@/components/Manifesto";
import Timetable from "@/components/Timetable";
import ChartGallery from "@/components/ChartGallery";
import BackToTop from "@/components/BackToTop";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <main data-testid="home-page" className="bg-[#050505] text-[#FDFBF7]">
      <div className="noise-overlay" />
      <Header />
      <Hero />
      <ResultsTicker />
      <EditorialMarquee />
      <DailyQuote />
      <TodayStrip />
      <Manifesto />
      <Timetable />
      <ChartGallery />
      <Footer />
      <BackToTop />
    </main>
  );
}
